import React, { useEffect } from 'react'

const RefundPolicy = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="m-auto my-20 max-md:my-4 w-[80%] justify-center items-center max-sm:py-8 max-sm:px-3 sm:p-8 border rounded-lg shadow-lg bg-white">
            <div className="sm:p-6">
                <h1 className="text-3xl font-bold mb-4 text-[#730000]">Refund Policy</h1>

                <div className="bg-gray-100 p-6 mt-6 rounded-lg">
                    <p className="mb-2">
                        At Select Proposal, your satisfaction is incredibly important to us. We strive to provide valuable services and ensure a positive experience for all our members.
                    </p>
                    <p className="mb-2">
                        While purchases made through our website are generally non-refundable, we believe in a fair and understanding approach. If you encounter an unforeseen circumstance or have a truly valid reason for a refund, we encourage you to contact us immediately after signing up.
                    </p>

                    <hr className="my-4 border-t border-gray-400" />

                    <h2 className="text-2xl font-semibold mb-2 text-[#730000]">
                        Here's how our refund policy works
                    </h2>
                    {/* <p className="mb-2">Here's how our refund policy works:</p> */}
                    <ul className="list-disc list-inside">
                        <li>
                            <span className='font-bold text-[#730000]'>Timely Request : </span>
                            Refund requests must be made promptly after your purchase, providing a genuine and valid reason.
                        </li>
                        <li>
                            <span className='font-bold text-[#730000]'>Non-Usage Confirmation : </span>
                            For a refund to be considered, we must have sufficient evidence that the purchased product or service has not been accessed, used, or duplicated in any way.
                        </li>
                        <li>
                            <span className='font-bold text-[#730000]'>Case-by-Case Review : </span>
                            All refund inquiries are reviewed carefully on an individual basis, and the final decision remains at our company's sole discretion.
                        </li>
                    </ul>

                    <hr className="my-4 border-t border-gray-400" />

                    <p className="mb-2">We are committed to resolving your concerns. Please reach out to our dedicated support team for any assistance with refund inquiries. We're here to help guide you through the process.
                    </p>
                </div>

            </div>
        </div>
    )
}

export default RefundPolicy
